<div class="container">

    <mat-dialog-content class="content-block">

        <app-tree-structure-icon></app-tree-structure-icon>

        <span class="message">Importing Selections</span>

        <span>This may take a minute...</span>

        <mat-progress-bar mode="determinate" [value]="loadingProgress"></mat-progress-bar>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="close-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>